import { useQuery } from "@tanstack/react-query";

// Interfaces
import { IFranchiseProps, IOEMProps, IProgramVersionDetailsArgs } from "./interfaces";

// Apis
import { getProgramDetails } from "@/Common/api/meta/queries";

// Helpers
import { getFranchiseOEM } from "@/Common/helpers/OEMs";

const getOEM = (args: IOEMProps) => {
	const { make = "", locationOEMs = [], isService = false } = args;
	if (!make || !locationOEMs?.length) {
		return null;
	}

	let oem = null;
	if (isService) {
		oem = locationOEMs.find((item) => item?.oemDisplayName === make);
	} else {
		oem = getFranchiseOEM(locationOEMs, make);
	}

	return oem;
};

const getFranchise = (args: IFranchiseProps) => {
	const { make = "", franchises = [], isService = false } = args;
	if (!make || !franchises?.length) {
		return null;
	}

	if (isService) {
		return franchises?.[0] || null;
	}

	return franchises?.find((item) => item?.franchise === make);
};

function useProgramVersionDetails(args: IProgramVersionDetailsArgs) {
	const { program, oemReference, version = "", department = "" } = args ?? {};
	if (!program || !oemReference) {
		return {
			data: {
				program,
				version,
				department,
				oemReference,
				details: null,
			},
			isLoading: false,
		};
	}

	const variables = {
		program,
		oemReference,
		filter: {
			department,
			version,
		},
	};

	const { data, isLoading } = useQuery({
		queryKey: ["programDetails", program, oemReference, version, department],
		queryFn: async () => getProgramDetails(variables),
		staleTime: Infinity,
		enabled: !!program && !!oemReference,
	});

	return {
		data,
		isLoading,
	};
}

export { useProgramVersionDetails, getOEM, getFranchise };
